"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Modal = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var react_dom_1 = __importDefault(require("react-dom"));
var styles_1 = require("./styles");
var consts_1 = require("./consts");
var utilts_1 = require("./utilts");
var Modal = function (_a) {
    var onClose = _a.onClose, children = _a.children, withoutInner = _a.withoutInner, fullScreen = _a.fullScreen, _b = _a.width, width = _b === void 0 ? 400 : _b;
    var portalParentElement = (0, react_1.useRef)((0, utilts_1.getPortalParentElement)()).current;
    var Container = fullScreen ? styles_1.FullScreenModalContainer : styles_1.ModalContainer;
    var handleKeyDown = function (event) {
        if (event.key === 'Escape') {
            onClose === null || onClose === void 0 ? void 0 : onClose();
        }
    };
    (0, react_1.useEffect)(function () {
        document.addEventListener('keydown', handleKeyDown);
        return function () {
            document.removeEventListener('keydown', handleKeyDown);
        };
    }, []);
    return react_dom_1.default.createPortal((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(styles_1.ModalBackdrop, { onClick: onClose, "data-testid": consts_1.TEST_ID_MODAL_CLOSE }), (0, jsx_runtime_1.jsx)(Container, { children: withoutInner ? children : (0, jsx_runtime_1.jsx)(styles_1.ModalInner, __assign({ style: { width: width } }, { children: children })) })] }), portalParentElement);
};
exports.Modal = Modal;
